import _Checkbox from './Checkbox'
import _CheckboxConnected from './Checkbox.container'

export const Checkbox = _Checkbox
export const CheckboxConnected = _CheckboxConnected



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/Checkbox/index.js